/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Tracking_ErrorInputs */

const en_delivery_board_tracking_error = /** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please paste a rider tracking link before dispatching`)
};

const es_delivery_board_tracking_error = /** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega un enlace de seguimiento antes de despachar`)
};

const fr_delivery_board_tracking_error = /** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez coller un lien de suivi de coursier avant l'envoi`)
};

const de_delivery_board_tracking_error = /** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte füge einen Tracking-Link ein, bevor du entsendest`)
};

const id_delivery_board_tracking_error = /** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harap tempel tautan pelacakan kurir sebelum mengirim`)
};

/** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */
const ja_delivery_board_tracking_error = en_delivery_board_tracking_error;

/** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */
const zh_delivery_board_tracking_error = en_delivery_board_tracking_error;

/** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */
const ar_delivery_board_tracking_error = en_delivery_board_tracking_error;

/** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */
const it_delivery_board_tracking_error = en_delivery_board_tracking_error;

/** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */
const ru_delivery_board_tracking_error = en_delivery_board_tracking_error;

/** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */
const pt_delivery_board_tracking_error = en_delivery_board_tracking_error;

/** @type {(inputs: Delivery_Board_Tracking_ErrorInputs) => LocalizedString} */
const ko_delivery_board_tracking_error = en_delivery_board_tracking_error;

/**
* | output |
* | --- |
* | "Please paste a rider tracking link before dispatching" |
*
* @param {Delivery_Board_Tracking_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_tracking_error = /** @type {((inputs?: Delivery_Board_Tracking_ErrorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Tracking_ErrorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_tracking_error(inputs)
	if (locale === "es") return es_delivery_board_tracking_error(inputs)
	if (locale === "fr") return fr_delivery_board_tracking_error(inputs)
	if (locale === "de") return de_delivery_board_tracking_error(inputs)
	if (locale === "ja") return ja_delivery_board_tracking_error(inputs)
	if (locale === "zh") return zh_delivery_board_tracking_error(inputs)
	if (locale === "ar") return ar_delivery_board_tracking_error(inputs)
	if (locale === "id") return id_delivery_board_tracking_error(inputs)
	if (locale === "it") return it_delivery_board_tracking_error(inputs)
	if (locale === "ru") return ru_delivery_board_tracking_error(inputs)
	if (locale === "pt") return pt_delivery_board_tracking_error(inputs)
	return ko_delivery_board_tracking_error(inputs)
});